/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.guides.ts
 *
 * Messages des GUIDES PAS À PAS personnalisés (2026-10-06) : le back-office
 * « Guides » (/admin/guides) et l'écran « Mon guide » (/mon-guide, dans
 * Plus). Fusionné dans fr.ts.
 *
 * Plateforme multi-événements : aucun nom d'événement ni « salon »,
 * « atelier », « exposant » écrits en dur ; le vocabulaire passe par les
 * jetons {lex...}. Apostrophe typographique partout (en ICU, l'apostrophe
 * droite échappe l'accolade qui la suit). Aucun tiret cadratin.
 *
 * Mikael - chef de projet - 2026-10-06
 */
export const messagesGuidesFr: Record<string, string> = {
  // ── Menu, titres ───────────────────────────────────────────────────────
  'adminNav.guides': 'Guides',
  'acces.titre.adminGuides': 'Guides',
  'acces.titre.monGuide': 'Mon guide',
  'guides.plus.lien': 'Mon guide',

  // ── Profils ────────────────────────────────────────────────────────────
  'guides.profil.exhibitor': '{lexExhibitorCap}',
  'guides.profil.recruiter': 'Recruteur rattaché',
  'guides.profil.workshop_host': 'Animateur {lexWorkshopOf}',
  'guides.profil.visitor': '{lexVisitorCap}',
  'guides.profil.student': 'Étudiant',
  'guides.profil.specific_public': 'Public spécifique',
  'guides.profil.staff': 'Équipe de scan',
  'guides.profil.backoffice': 'Organisation',

  // ── Motifs d'exclusion ─────────────────────────────────────────────────
  'guides.exclusion.sans_adresse': 'sans adresse',
  'guides.exclusion.bloque': 'compte bloqué',
  'guides.exclusion.archive': 'compte archivé',
  'guides.exclusion.en_attente': 'compte en attente de validation',
  'guides.exclusion.mineur': 'mineur',

  // ── Back-office : en-tête et onglets ───────────────────────────────────
  'guides.admin.titre': 'Guides',
  'guides.admin.intro':
    'Les guides pas à pas, un par public. Chaque personne reçoit le sien par un lien personnel, précédé d’une page à son nom : badge, stand, horaires, ce qu’il lui reste à faire.',
  'guides.admin.refus': 'Cette page n’est pas ouverte à votre compte. Elle s’accorde dans Contrôle d’accès, par rôle ou par compte.',
  'guides.admin.chargement': 'Chargement des guides…',
  'guides.admin.erreur': 'Les guides n’ont pas pu être chargés. Réessayez dans un instant.',
  'guides.onglet.guides': 'Les guides',
  'guides.onglet.envoyer': 'Envoyer',
  'guides.onglet.historique': 'Historique',

  // ── Carte d'un guide ───────────────────────────────────────────────────
  'guides.carte.public': 'Pour : {profils}',
  'guides.carte.publicPremium': 'Pour : {profils}, entreprises premium seulement',
  'guides.carte.enService':
    'PDF en service : {pages, plural, one {# page} other {# pages}}, {taille}, version {version}, déposé le {date}.',
  'guides.carte.absent': 'Aucun PDF en service : déposez-en un pour pouvoir l’envoyer.',
  'guides.carte.fusion': 'La page personnelle est placée devant le guide, dans un seul fichier.',
  'guides.carte.separe':
    'Ce PDF ne peut pas recevoir la page personnelle : la page et le guide sont proposés côte à côte, sur la même page de téléchargement.',
  'guides.carte.compteurs':
    '{ayants, plural, =0 {Personne n’y a droit} one {# personne y a droit} other {# personnes y ont droit}}, {envoyables} joignables par courriel, {envoyes} déjà servies, {telecharges} téléchargements.',
  'guides.carte.televerser': 'Téléverser une nouvelle version (PDF)',
  'guides.carte.televerse': 'Nouvelle version en service.',
  'guides.carte.identique': 'Ce fichier est déjà celui en service : rien n’a changé.',
  'guides.carte.pasPdf': 'Choisissez un fichier PDF.',
  'guides.carte.apercu': 'Aperçu personnalisé',
  'guides.carte.apercuPour': 'Pour qui',
  'guides.carte.apercuChoisir': 'Choisir une personne',
  'guides.carte.apercuOuvrir': 'Ouvrir l’aperçu (PDF)',
  'guides.carte.textes': 'Titre et phrase du courriel',
  'guides.carte.titre': 'Titre du guide',
  'guides.carte.description': 'Ce que le guide explique (repris dans le courriel)',
  'guides.carte.enregistrer': 'Enregistrer les textes',
  'guides.carte.enregistre': 'Textes enregistrés.',

  // ── Envoi ──────────────────────────────────────────────────────────────
  'guides.envoi.guide': 'Guide à envoyer',
  'guides.envoi.destinataires': 'Destinataires',
  'guides.envoi.mode.tous': 'Tout le public du guide',
  'guides.envoi.mode.profil': 'Tout un profil',
  'guides.envoi.mode.selection': 'Une sélection',
  'guides.envoi.mode.personne': 'Une seule personne',
  'guides.envoi.profil': 'Profil',
  'guides.envoi.rechercher': 'Rechercher (nom, structure, adresse)',
  'guides.envoi.filtreProfil': 'Filtrer par profil',
  'guides.envoi.filtreStructure': 'Filtrer par structure',
  'guides.envoi.tous': 'Tous',
  'guides.envoi.toutes': 'Toutes',
  'guides.envoi.cocherVisibles': 'Cocher les personnes affichées',
  'guides.envoi.decocher': 'Tout décocher',
  'guides.envoi.coches': '{n, plural, =0 {Aucune personne cochée} one {# personne cochée} other {# personnes cochées}}',
  'guides.envoi.aucunePersonne': 'Personne ne correspond à ces filtres.',
  'guides.envoi.dejaEnvoye': 'déjà envoyé le {date}',
  'guides.envoi.telecharge': 'téléchargé le {date}',
  'guides.envoi.ecarte': 'écarté : {motif}',
  'guides.envoi.preparer': 'Préparer l’envoi',
  'guides.envoi.resume':
    '{n, plural, =0 {Aucun destinataire} one {# destinataire} other {# destinataires}} pour « {guide} ».',
  'guides.envoi.exclus': 'Écartés d’office : {liste}.',
  'guides.envoi.horsGuide': '{n, plural, one {# personne cochée n’a} other {# personnes cochées n’ont}} pas droit à ce guide : ignorées.',
  'guides.envoi.deja':
    '{n, plural, one {# personne l’a déjà reçu} other {# personnes l’ont déjà reçu}} : {noms}.',
  'guides.envoi.renvoyer': 'Leur renvoyer aussi le guide',
  'guides.envoi.dejaEcartees': 'Sans cette case, elles sont écartées de l’envoi.',
  'guides.envoi.apercuTitre': 'Le courriel, tel que le recevra {pour}',
  'guides.envoi.sujet': 'Objet : {sujet}',
  'guides.envoi.essai': 'M’envoyer un essai',
  'guides.envoi.essaiParti': 'Essai envoyé à {adresse}, avec le courriel de {modele}.',
  'guides.envoi.envoyer': '{n, plural, one {Envoyer à # personne} other {Envoyer à # personnes}}',
  'guides.envoi.enCours': 'Envoi en cours : {faits} sur {total}…',
  'guides.envoi.termine':
    'Envoi terminé : {envoyes, plural, one {# courriel parti} other {# courriels partis}}, {echecs, plural, =0 {aucun échec} one {# échec} other {# échecs}}{ignores, plural, =0 {} one {, # personne écartée entre-temps} other {, # personnes écartées entre-temps}}.',
  'guides.envoi.guideAbsent': 'Ce guide n’a pas encore de PDF en service : déposez-le dans l’onglet « Les guides ».',
  'guides.envoi.choisirPersonne': 'Choisissez au moins une personne.',

  // ── Historique ─────────────────────────────────────────────────────────
  'guides.historique.guide': 'Guide',
  'guides.historique.vide': 'Ce guide n’a encore été envoyé à personne.',
  'guides.historique.personne': 'Personne',
  'guides.historique.structure': 'Structure',
  'guides.historique.envoyeLe': 'Envoyé le',
  'guides.historique.par': 'Par',
  'guides.historique.statut': 'Statut',
  'guides.historique.ouvert': 'Lien ouvert',
  'guides.historique.telecharge': 'Téléchargé',
  'guides.historique.non': 'non',
  'guides.historique.fois': '{date} ({n, plural, one {# fois} other {# fois}})',
  'guides.statut.envoye': 'envoyé',
  'guides.statut.echec': 'échec',
  'guides.statut.ignore': 'écarté',
  'guides.statut.en_cours': 'en cours',

  // ── Envoi automatique (2026-10-07) ─────────────────────────────────────
  'guides.auto.titre': 'Envoi automatique',
  'guides.auto.intro':
    'Deux fois par jour, chaque personne devenue joignable (compte validé, par exemple) qui n’a jamais reçu son guide le reçoit, avec la même page personnelle et le même lien que pour un envoi d’ici.',
  'guides.auto.interrupteur': 'Envoi automatique actif',
  'guides.auto.actif': 'Actif : passages à {horaires}, chaque jour.',
  'guides.auto.inactif': 'Éteint : aucun guide ne part automatiquement.',
  'guides.auto.allume': 'Envoi automatique allumé.',
  'guides.auto.eteint': 'Envoi automatique éteint.',
  'guides.auto.fin': 'Fin automatique : le {date} à 23 h 59, soir du dernier jour de l’événement.',
  'guides.auto.sansDate': 'Date de l’événement inconnue : l’envoi automatique ne tourne pas.',
  'guides.auto.termine': 'L’événement est terminé : l’envoi automatique est clos.',
  'guides.auto.prochain': 'Prochain passage : le {jour} à {heure}.',
  'guides.auto.aucunProchain': 'Plus aucun passage prévu.',
  'guides.auto.dernier':
    'Dernier passage : le {date}, {envoyes, plural, =0 {aucun guide envoyé} one {# guide envoyé} other {# guides envoyés}}{echecs, plural, =0 {} one {, # échec} other {, # échecs}}.',
  'guides.auto.dernierRaison': 'Dernier passage : le {date}. {raison}',
  'guides.auto.jamais': 'Aucun passage pour l’instant.',
  'guides.auto.guide':
    '{titre} : {n, plural, =0 {personne à servir} one {# personne au prochain passage} other {# personnes au prochain passage}}{attente, plural, =0 {} one {, # compte en attente de validation} other {, # comptes en attente de validation}}.',
  'guides.auto.guideSansPdf': '{titre} : aucun PDF en service, ignoré.',
  'guides.auto.resume.copies':
    '{n, plural, one {Après chaque passage qui envoie un guide, un résumé part à l’adresse en copie des envois d’accès (écran « Codes d’accès »).} other {Après chaque passage qui envoie un guide, un résumé part aux # adresses en copie des envois d’accès (écran « Codes d’accès »).}}',
  'guides.auto.resume.super_admins':
    '{n, plural, one {Après chaque passage qui envoie un guide, un résumé part au super administrateur (aucune adresse en copie réglée).} other {Après chaque passage qui envoie un guide, un résumé part aux # super administrateurs (aucune adresse en copie réglée).}}',
  'guides.auto.resume.aucun': 'Aucune adresse ne recevra le résumé des passages : réglez les copies sur l’écran « Codes d’accès ».',
  'guides.auto.derniers': 'Derniers envois automatiques',
  'guides.auto.aucunEnvoi': 'Aucun envoi automatique pour l’instant.',
  'guides.auto.colGuide': 'Guide',

  // ── Mon guide (participant) ────────────────────────────────────────────
  'monGuide.titre': 'Mon guide',
  'monGuide.intro': 'Votre guide pas à pas, précédé d’une page à votre nom qui reprend ce que l’application sait de vous aujourd’hui.',
  'monGuide.chargement': 'Préparation de votre guide…',
  'monGuide.erreur': 'Votre guide n’a pas pu être chargé. Réessayez dans un instant.',
  'monGuide.aucun': 'Aucun guide ne correspond encore à votre profil.',
  'monGuide.telecharger': 'Télécharger mon guide (PDF)',
  'monGuide.page': 'Ma page personnelle (PDF)',
  'monGuide.guideSeul': 'Le guide (PDF)',
  'monGuide.pasEncore': 'Ce guide n’est pas encore en ligne.',
  'monGuide.taille': 'Fichier de {taille}, à garder sur votre téléphone ou à imprimer.',
  'monGuide.infos': 'Vos informations',
  'monGuide.structure': 'Structure',
  'monGuide.badge': 'Identifiant du badge',
  'monGuide.stand': 'Stand',
  'monGuide.ateliers': '{n, plural, one {Votre {lexWorkshopBare}} other {Vos {lexWorkshopPlural}}}',
  'monGuide.lieu': 'lieu : {salle}',
  'monGuide.lieuAConfirmer': 'lieu à confirmer',
  'monGuide.premium': 'CV Matching premium',
  'monGuide.premiumCreneaux': '{libres} créneaux libres, {confirmes} confirmés',
  'monGuide.fiche': 'Où en est votre fiche',
  'monGuide.photoOui': 'Photo déposée.',
  'monGuide.photoNon': 'Photo pas encore déposée.',
  'monGuide.postes': '{n, plural, =0 {Aucun poste publié.} one {# poste publié.} other {# postes publiés.}}',
  'monGuide.aFaire': 'À faire avant {jour} :',
  'monGuide.complet': 'Rien ne manque : votre profil est complet.',
};
